import React from 'react';
import Card from '../Card';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';
import { useVerifyAdmin, useVerifyInstaller } from '../../helper';
import { useGetIDsFromURL } from 'components/DeviceDetails/helper';
import { useGetSiteData } from './helper';

const NoDevicesAvailable = () => {
    const isAdmin = useVerifyAdmin();
    const isInstaller = useVerifyInstaller();
    const navigate = useNavigate();
    const { Site_ID } = useGetIDsFromURL();
    const { data: siteData } = useGetSiteData(Site_ID);

    return (
        <Card>
            <div className="flex flex-col items-center justify-center py-5">
                <h1 className="text-2xl font-bold opacity-30">
                    No Devices Available
                </h1>
                {(isAdmin || isInstaller) && (
                    <>
                        <p className="text-center opacity-30">
                            Would you like to add a device?
                        </p>
                        <div className="mt-3 flex justify-center">
                            <Button
                                onClick={() =>
                                    navigate(
                                        `/sites/${siteData?.Site_ID}/add-device`,
                                        {
                                            state: siteData,
                                        }
                                    )
                                }
                            >
                                Add device
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </Card>
    );
};

export default NoDevicesAvailable;
